import { applyH, perspectiveTransform, type Pt } from './projection';

const clamp01 = (v: number) => Math.min(1, Math.max(0, v));

/** Полка стеллажа с ОДНОЙ полкой едет за полигоном стеллажа (Алексей 14.10, #1547:
 *  «single-shelf rack… не приходилось 2 таскать отдельно», типичный случай — «Товар на
 *  кассе»). Полке применяется та же трансформация, что перевела старый контур стеллажа в
 *  новый: если оба контура четырёхугольники — гомография по углам (перенос, растяжение,
 *  перспектива), иначе — сдвиг на разницу центроидов. Относительное положение полки внутри
 *  стеллажа сохраняется, поэтому полка, вписанная в стеллаж с отступом, таким и останется. */
export function followRack(oldRack: Pt[], newRack: Pt[], shelf: Pt[]): Pt[] {
  if (oldRack.length === 4 && newRack.length === 4) {
    try {
      const H = perspectiveTransform(oldRack, newRack);
      return shelf.map((p) => {
        const [x, y] = applyH(H, p);
        return [clamp01(x), clamp01(y)] as Pt;
      });
    } catch {
      // вырожденный четырёхугольник — ниже обычный сдвиг
    }
  }
  const c = (pts: Pt[]): Pt => [
    pts.reduce((s, p) => s + p[0], 0) / pts.length,
    pts.reduce((s, p) => s + p[1], 0) / pts.length,
  ];
  const [ox, oy] = c(oldRack);
  const [nx, ny] = c(newRack);
  return shelf.map(([x, y]) => [clamp01(x + nx - ox), clamp01(y + ny - oy)] as Pt);
}

/** Насколько контур изменился — чтобы не трогать полку при сохранении без правки. */
export function pointsDiffer(a: Pt[], b: Pt[], eps = 1e-6): boolean {
  if (a.length !== b.length) return true;
  return a.some((p, i) => Math.abs(p[0] - b[i][0]) > eps || Math.abs(p[1] - b[i][1]) > eps);
}
